const MusicRegistrationHeader = () => (
  <header className="relative z-10 border-b border-gray-200 bg-white">
    <div className="mx-auto flex min-h-20 max-w-6xl items-center px-5 sm:px-8">
      <span className="select-none font-brand text-2xl font-bold text-[#2F5249]">Tutor Founder</span>
    </div>
  </header>
);

export default MusicRegistrationHeader;
